import React, { useEffect, useState } from 'react';
import "./Details.css";
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { eye } from 'react-icons-kit/feather/eye';
import { arrowUpRight } from 'react-icons-kit/feather/arrowUpRight'
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { useJwt } from "react-jwt";
import { GetFeedbackById } from '../apiconfig/authService';
import { RiLoaderFill } from "react-icons/ri";

function ViewFeedback() {
    const navigate = useNavigate();
    const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
    if (isExpired)
        navigate('/');

    const { feedbackid } = useParams();
    const [loading, setLoading] = useState(false);

    const [feedbackData, setFeedbackData] = useState({});

    const formatUTCDate = (utcDateString) => {
      const date = new Date(utcDateString);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // convert 0 → 12, 13 → 1, etc.
      hours = String(hours).padStart(2, "0");

      return `${day}-${month}-${year} at ${hours}:${minutes}:${seconds} ${ampm}`;
    };

    useEffect(() => {
        (
            async () => {
                setLoading(true);
                try {
                    const response = await GetFeedbackById(feedbackid, localStorage.getItem('accessToken'));
                    setLoading(false);
                    setFeedbackData(response.data);
                } catch (error) {
                    console.log(error);
                } finally {
                    setLoading(false);
                }
            }
        )();
    }, []);


    return (
        <div className="dashboard-content">
            {/* <div className="mobileOption d-flex align-items-center justify-content-between">
                <div  className="buyMore"><img className="img-fluid" src={logoImg} alt=""/></div>
                <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
            </div> */}
            <Sidebar />
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-center pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Feedback Details</h1>
                    <div className="d-inline-flex gap-2">
                        <NavLink to="/feedback" className="btn btn-primary addSeller"><Icon className="eye" icon={eye} size={18} /> View All</NavLink>
                    </div>
                </div>
                {
                    loading ?
                        <div className="d-flex align-items-center justify-content-center">
                            <RiLoaderFill size={40} className="text-success spin-animation text-center" />
                        </div>
                        :
                        <div className="detailsBox">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h4 className="text-primary h6 fw-bold">Feedback Information</h4>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover w-100">
                                            <tbody>
                                                <tr>
                                                    <th>Feedback ID</th>
                                                    <td>{feedbackData.feedbackid}</td>
                                                </tr>
                                                <tr>
                                                    <th>Feedback</th>
                                                    <td>{feedbackData.feedback}</td>
                                                </tr>
                                                <tr>
                                                    <th>Created Date</th>
                                                    <td>{formatUTCDate(feedbackData?.createddate)}</td>
                                                </tr>
                                                <tr>
                                                    <th>Modified Date</th>
                                                    <td>{formatUTCDate(feedbackData?.modifieddate)}</td>
                                                </tr>
                                                <tr>
                                                    <th>Created By</th>
                                                    <td>{feedbackData?.createdby}</td>
                                                </tr>
                                                <tr>
                                                    <th>Modified By</th>
                                                    <td>{feedbackData?.modifiedby}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <h4 className="text-primary h6 fw-bold">Customer Information</h4>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover w-100">
                                            <tbody>
                                                <tr>
                                                    <th>Customer Name</th>
                                                    <td>{feedbackData.customerInfo?.name}</td>
                                                </tr>
                                                <tr>
                                                    <th>Customer Phone Number</th>
                                                    <td>{feedbackData.customerInfo?.customerphone}</td>
                                                </tr>
                                                <tr>
                                                    <th>Customer Email ID</th>
                                                    <td>{feedbackData.customerInfo?.emailid}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                }
            </div>
        </div>
    );
}
export default ViewFeedback;